export default function isNil(value): value is null | undefined {
  return value == null;
}
